/**
 *  使用 ANTD PRO 布局
 */
import ProLayout  from '@ant-design/pro-layout';
import { Badge} from "antd";
import React, { useState, useRef } from 'react';
import { Link } from "react-router-dom";
import HeaderSearch from "@components/HeaderSearch/HeaderSearch";
import Auth from "@utils/auth";
import IconEssaone from "@components/Icon/Essaone";
/** Use Authorized check all menu item */
const BasicLayout = (props) => {
    const {
        children,
        location = {
            pathname: '/',
        },
        menuData = [],
        loading = false,
        userName="",
        redPointDigital = {}
        // selectedMenuKeys=[] //pro 路由自动匹配
    } = props;
    const menuDataRef = useRef([]);
    const [collapse, setCollapse,] = useState(false);
    const logout = ()=>{
        Auth.logout();
        props.history.push("/login");
    }
    /**
     * 菜单 是否收缩
     * */
    const handleMenuCollapse = (payload) => {
        setCollapse(payload)
    };
    const goTop  = ()=> {
        $(document).scrollTop(0);
    }
    return (
        <>
            <ProLayout siderWidth={250}
                       heightLayoutHeader={56}
                       layout={'mix'}
                       disableMobile={true}
                       collapsed={collapse}
                       onCollapse={()=>handleMenuCollapse(!collapse)}
                       // onPageChange={()=>{
                       //     onPageChange()
                       // }}
                       headerRender={(ProLayoutProps)=>{return(<div className="essaone-pro-header flex-item-ver-center flex-item-between">
                           <Link className="logo flex-item-ver-center"
                                 to={`/`} >
                               <IconEssaone size={20} color={"#fff"}/>
                           </Link>
                            <HeaderSearch />
                            <div className={"flex-item-ver-center"}>
                                <div className={"user margin-right-5"}>
                                    <i className="ri-user-line"></i>
                                </div>
                                <span className={"color-white"}>{userName}</span>
                                {/* 退出 */}
                                <span className={"logout color-white ml_8 cursor-p"} onClick={()=>logout()}>
                                    <i className="ri-logout-box-r-line color-white" ></i>
                                </span>
                            </div>
                        </div>)}}
                        menuItemRender={(menuItemProps, defaultDom,BaseMenuProps) => {
                            // if (
                            //     menuItemProps.isUrl ||
                            //     !menuItemProps.path ||
                            //     location.pathname === menuItemProps.path
                            // ) {
                            //     return defaultDom;
                            // }
                            //一级菜单 显示图标 ，无子项菜单 需要显示 具体小红点 数量
                           if(collapse&&menuItemProps.level==1) {
                               // console.log("末級",menuItemProps)
                           }
                            const num = menuItemProps.redCode? (redPointDigital[menuItemProps.redCode]||0):0;
                            return (<Link to={menuItemProps.path} className={collapse&&menuItemProps.level==1?"":"flex-item-between"} title={menuItemProps.name}>
                                {/* ellipsis */}
                                <span className={collapse?"icon-collapsed":""}>
                                    {menuItemProps.level==1&&menuItemProps.icon&&(num?<Badge dot>
                                        <i className={menuItemProps.icon+" font-18 black45 mr_8"} />
                                    </Badge>:<i className={menuItemProps.icon+" font-18 black45 mr_8"} />)}
                                    {collapse&&menuItemProps.level==1?"":menuItemProps.name}
                                </span>
                                {menuItemProps.level!=1&&num?<Badge count={num>99?"99+":num} />:null}
                            </Link>);
                        }}
                        subMenuItemRender={(itemProps={}) => {
                            let num = 0;
                            if(itemProps.children&&itemProps.children.length>0){
                                itemProps.children.forEach((item={})=>{
                                    num += item.redCode?(redPointDigital[item.redCode]||0):0;
                                })
                            }
                             return (<span className={collapse?"icon-collapsed":""}>
                                    {itemProps.level==1&&itemProps.icon&&(num?<Badge dot>
                                        <i className={itemProps.icon+" font-18 black45"} />
                                    </Badge>:<i className={itemProps.icon+" font-18 black45"} />)}
                                    {(!collapse||!itemProps.icon)&&<span className={"ml_8 font-14 black66"}>{itemProps.name}</span>}
                            </span>)}
                        }
                       menuDataRender={()=>menuData}
                       menu={{ loading }}
                       postMenuData={(menuData) => {
                            menuDataRef.current = menuData || [];
                            return menuData || [];
                        }} >
                    {/* <Authorized authority={authorized.authority} noMatch={noMatch}> */}
                        {children}
                    {/* </Authorized> */}
                </ProLayout>
            {/*<SettingDrawer*/}
                {/*settings={settings}*/}
                {/*onSettingChange={(config) =>*/}
                    {/*dispatch({*/}
                        {/*type: 'settings/changeSetting',*/}
                        {/*payload: config,*/}
                    {/*})*/}
                {/*}*/}
            {/*/>*/}
        </>
    );
};

export default BasicLayout;